import React from 'react';
import { Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FilterChipProps {
  label: string,
  onClick?: () => void,
  onDelete: () => void,
}

export const CustomerFilterChip = ({ label, onClick, onDelete }: FilterChipProps) => (
  <Chip
    deleteIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
    label={label}
    onClick={onClick}
    onDelete={onDelete}
    size="medium"
    sx={{
      backgroundColor: '#E2ECB5',
      borderRadius: 2,
      px: 0.5,
      py: 0.25,
      fontSize: '0.875rem',
      fontWeight: 500,
      '& .MuiChip-deleteIcon': {
        borderRadius: '50%',
        '&:hover': {
          color: 'black',
        },
      },
    }}
  />
);
